<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">{{ title }} Bank External</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-row>
              <v-col cols="12" md="6" lg="4" xl="4">Name</v-col>
              <v-col cols="12" md="6" lg="8" xl="8">
                <v-text-field
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="form.name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" lg="4" xl="4">Code</v-col>
              <v-col cols="12" md="6" lg="8" xl="8"
                ><v-text-field
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="form.code"
                ></v-text-field
              ></v-col>
              <v-col cols="12" md="6" lg="4" xl="4">Swift Code</v-col>
              <v-col cols="12" md="6" lg="8" xl="8"
                ><v-text-field
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="form.swiftCode"
                ></v-text-field
              ></v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" @click="close">
          close
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "dialog-form-bank-external",
  props: {
    dialog: Boolean,
    form: Object,
    title: String,
  },
  methods: {
    close() {
      this.$emit("close");
    },
    save() {
      this.$emit("save", this.form);
    },
  },
};
</script>

<style></style>
